export const modalPlaces = {
	message:
		"Utilize a tabela abaixo para ativar e desativar o {{ groupOrProfile }} fiscal em sua organização.",
	group: "Grupo",
	profile: "Perfil",
	title: "Locais vinculados ao {{ groupOrProfile }} fiscal: {{ name }}",
	searchPlace: "Pesquisar place",
	placesAt: "Places em",
};
